/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import classNames from 'classnames';
import ExternalLink from '../ExternalLink/ExternalLink';
import MediaPreviewFile2 from '../MediaPreviewFile2/MediaPreviewFile2.js';

function MediaPreviewImage2({
  onClick,
  imageUrl,
  linkUrl,
  title,
  minimal,
  fileName,
}: {
  onClick?: (url: string) => void;
  imageUrl: string;
  linkUrl: string;
  title: string;
  fileName: string;
  minimal?: boolean;
}) {
  const wrappedHandleClick = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    onClick?.(imageUrl);
  };

  const isLarge = false;
  const image = (
    <div
      className={classNames(
        'flex h-full flex-grow contain-content',
        isLarge ? 'min-w-[300px]' : 'min-w-[100px] min-h-[100px] max-h-[80vh] max-w-[768px]',
      )}
    >
      <img src={imageUrl} alt="" className="mb-2 object-contain w-full" />
    </div>
  );
  if (minimal) {
    return <MediaPreviewFile2 linkUrl={linkUrl} fileName={fileName} />;
  }
  if (linkUrl && linkUrl !== imageUrl) {
    return (
      <div className="contain-content" data-testid="MediaPreviewImage">
        <ExternalLink
          className="flex h-full max-h-full contain-content flex h-full lg:h-auto max-h-full contain-content flex flex-col h-full max-w-full w-full max-h-full contain-content"
          url={linkUrl}
        >
          {image}
          {title && <p className="text-sm">{title}</p>}
        </ExternalLink>
      </div>
    );
  }
  return (
    <div
      className="flex h-full max-h-full contain-content flex-1"
      data-testid="MediaPreviewImage"
      onClick={wrappedHandleClick}
    >
      {image}

      {title && <p className="text-sm">{title}</p>}
    </div>
  );
}

export default MediaPreviewImage2;
